/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * Copyright IBM Corp. 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'bi/glass/app/plugins/ButtonActionInterface'
], function(ButtonActionInterface) {
	'use strict';

	const BrandTextController = ButtonActionInterface.extend({
		onPress(context) {
			context.glassContext.openAppView();
		}
	});

	return BrandTextController;
});
